import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

import aguid from 'lib/aguid';

const FOLDERS: Record<'image' | 'video', string> = {
  image: 'imageCards',
  video: 'videoCards',
};

// Uploads an Image or Video card's file to a new path in the account's
// storage, resolving with the path to save as its imageSrc or videoSrc.
// Never overwrites: the file a saved card shows stays until it's replaced.
const uploadCardMedia = async ({
  accountId,
  kind,
  file,
}: {
  accountId: string;
  kind: 'image' | 'video';
  file: File;
}): Promise<string> => {
  const path = `accounts/${accountId}/${FOLDERS[kind]}/${aguid()}`;
  await firebase
    .storage()
    .ref(path)
    .put(
      file,
      // As the classic forms upload them: images cached for a week
      kind === 'image' ? { cacheControl: 'max-age=604800' } : undefined,
    );
  return path;
};

export default uploadCardMedia;
